import type { N1TierLabel } from './assets/n1Manifest';

/** Logical canvas. 16:9, FIT-scaled and centred by Phaser's ScaleManager. */
export const GAME_WIDTH = 1280;
export const GAME_HEIGHT = 720;

/** Phaser texture key for the loaded N1 tier. */
export const N1_TEXTURE_KEY = 'georgi-n1';
/** Manifest URL, relative to index.html (public/data). */
export const N1_MANIFEST_URL = 'data/georgi-n1.manifest.json';
/**
 * Tier the game loads — the one switch. smooth@1x = 36-frame loops and 24-frame transitions on a
 * 320 px page so 0.2–0.35 s transitions and the loops show a new frame on every render frame;
 * keys@1x = half the frames (18 / 12 per action) if a device needs it.
 */
export const N1_TIER: N1TierLabel = 'smooth@1x';

/** Gallery layout: two rows on their own ground lines, 1:1 sprites. */
export const GALLERY = {
  columns: 7,
  groundY: [300, 660] as const,
  labelOffset: 16,
  /** Animation time scales cycled with keys 1–5. 1× = the manifest's review timing. */
  rates: [1, 2, 4, 8, 16] as const,
} as const;
